module.exports = __webpack_public_path__ + "app-static/img/guide3.d09a2aa8.png";